<template src="./save.html"></template>

<script>
import axios from 'axios'
  import { store } from '../../../store/store'
  import swal from 'sweetalert2'

  export default {
    name: 'save',
    props: {
      category: {
        type: Object
      },
      getCategories: {
        type: Function
      }
    },
    computed: {
      type: function () {
        return this.category.id ? 'Edit' : 'Create New'
      },
      availableParentCategories: function () {
        // Filter out the current category and its descendants to prevent circular references
        if (!this.category.id) {
          return this.$store.getters['category/getAll'];
        }
        
        const filterDescendants = (categories, excludeId) => {
          return categories.filter(cat => {
            if (cat.id === excludeId) return false;
            
            // Check if this category is a descendant of the excluded category
            const isDescendant = (checkId, targetId) => {
              if (checkId === targetId) return true;
              const parent = categories.find(c => c.id === checkId);
              return parent && parent.parent_id > 0 ? isDescendant(parent.parent_id, targetId) : false;
            };
            
            return !isDescendant(cat.id, excludeId);
          });
        };
        
        return filterDescendants(this.$store.getters['category/getAll'], this.category.id);
      }
    },
    data: function () {
      return {
        errors: {},
        loading: false
      }
    },
    methods: {
      validate: function () {
        this.errors = {};
        
        if (!this.category.name || this.category.name.trim().length < 2) {
          this.errors.name = 'Name must be at least 2 characters long';
        }
        
        if (this.category.name && this.category.name.trim().length > 255) {
          this.errors.name = 'Name cannot exceed 255 characters';
        }
        
        if (this.category.description && this.category.description.length > 1000) {
          this.errors.description = 'Description cannot exceed 1000 characters';
        }
        
        return Object.keys(this.errors).length === 0;
      },
      save: function (close = true) {
        if (!this.validate()) {
          return;
        }
        
        this.loading = true;
        
        const categoryData = {
          name: this.category.name.trim(),
          description: this.category.description ? this.category.description.trim() : '',
          parent_id: this.category.parent_id || null
        };
        
        if (!this.category.id) {
          // Create new category
          axios.post('/api/category', categoryData)
            .then(response => {
              this.successNotification('Category created successfully');
              if (close) { this.closeModal(); }
              this.getCategories();
            })
            .catch(error => {
              this.handleError(error, 'Failed to create category');
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          // Update existing category
          axios.put('/api/category/' + this.category.id, categoryData)
            .then(response => {
              this.successNotification('Category updated successfully');
              if (close) { this.closeModal(); }
              this.getCategories();
            })
            .catch(error => {
              this.handleError(error, 'Failed to update category');
            })
            .finally(() => {
              this.loading = false;
            });
        }
      },
      deleted: function () {
        swal({
          title: 'Are you sure?',
          text: 'Delete the category "' + this.category.name + '"? This action cannot be undone.',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            if (this.category.id) {
              this.loading = true;
              axios.delete('/api/category/' + this.category.id)
                .then(response => {
                  swal(
                    'Deleted',
                    'The category has been deleted successfully',
                    'success'
                  );
                  this.closeModal();
                  this.getCategories();
                })
                .catch(error => {
                  this.handleError(error, 'Failed to delete category');
                })
                .finally(() => {
                  this.loading = false;
                });
            }
          }
        });
      },
      handleError: function (error, defaultMessage) {
        let message = defaultMessage;
        if (error.response && error.response.data && error.response.data.error) {
          message = error.response.data.error;
        }
        swal('Error', message, 'error');
      },
      successNotification: function (message) {
        swal({
          title: 'Success',
          text: message,
          type: 'success',
          timer: 2000,
          showConfirmButton: false
        });
      },
      closeModal: function () {
        this.$emit('close');
      }
    }
  }
</script>

<style scoped>
.error {
  border-color: var(--color-error) !important;
}

.error-message {
  color: var(--color-error);
  font-size: 0.875em;
  margin-top: 0.25rem;
}

.field.error label {
  color: var(--color-error);
}

.ui.button.loading {
  pointer-events: none;
}
</style>

